module.exports = __webpack_public_path__ + "2f61a6ad821a3afac93d0a53d82cd1c5.svg";